// hooks
import { useUser } from "contexts/UserContext";
import { useDataTransferContext } from "../../contexts/DataTransferContext";
// components
import ImportedUI from "./components/imported-ui";
// styles
import styles from "./Imported.module.scss";

/**
 * renders UI for recent imports in data transfer page
 */
const Imported = () => {
  const { defaultUserTimezone } = useUser();
  const { importTasks } = useDataTransferContext();

  return (
    <article className={styles["imported"]}>
      <h2 className={styles["imported__title"]}>All Imports</h2>
      <ImportedUI tasks={importTasks} timezone={defaultUserTimezone} />
    </article>
  );
};

export default Imported;
